import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, ArrowRight } from 'lucide-react';

export const FMEACard = ({ index }) => {
  const navigate = useNavigate();

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] }
    }
  };

  const handleCardClick = () => {
    navigate('/FMEA-Training');
  };

  return (
    <motion.div
      variants={cardVariants}
      className="relative h-[420px]"
    >
      <motion.div
        className="relative h-full bg-white rounded-2xl shadow-md cursor-pointer overflow-hidden border-2 border-transparent hover:shadow-xl hover:scale-[1.02] transition-all duration-300"
        onClick={handleCardClick}
        whileHover={{ borderColor: 'rgba(14, 165, 233, 0.2)' }}
      >
        <div className="p-6 h-full flex flex-col">
          {/* Icon with gradient background */}
          <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-blue-600 via-cyan-600 to-teal-600 flex items-center justify-center mb-4 shadow-lg">
            <AlertTriangle className="h-8 w-8 text-white" />
          </div>

          {/* Badge */}
          <div className="inline-block px-3 py-1 rounded-full text-xs font-semibold text-cyan-700 bg-cyan-50 self-start mb-3">
            Risk Analysis
          </div>

          {/* Title */}
          <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
            FMEA Training
          </h3>

          {/* Gradient underline */}
          <div className="h-1 w-16 bg-gradient-to-r from-blue-600 via-cyan-600 to-teal-600 rounded-full mb-4"></div>

          {/* Description */}
          <p className="text-gray-600 text-sm leading-relaxed flex-1 line-clamp-4">
            Master Failure Mode and Effects Analysis (FMEA) to identify risks early, improve product quality, and enhance process reliability. Learn DFMEA, PFMEA, SFMEA, and FMEA-MSR techniques for proactive risk prevention.
          </p>

          {/* View Details Link */}
          <div className="flex items-center gap-2 text-cyan-600 font-semibold text-sm mt-4">
            <span>View Training Details</span>
            <ArrowRight className="h-4 w-4" />
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};
